document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.vacature_filter-layout").forEach((layout) => {
        const form = layout.querySelector(".filters-col");
        const results = layout.querySelector(".results-col");
        const grid = layout.querySelector("[data-results]");
        const pagination = layout.querySelector("[data-pagination]");
        const label = layout.querySelector("[data-results-label]");
        const empty = layout.querySelector("[data-results-empty]");
        const count = layout.querySelector("[data-filter-count]");
        const reset = layout.querySelector(".filters-reset");
        const stacked = window.matchMedia("(max-width: 992px)");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        if (!form || !grid || !layout.dataset.ajaxUrl) return;

        form.classList.add("is-enhanced");

        // Checked values per group as one comma separated parameter, so the URL stays short and readable.
        const query = (page = 1) => {
            const params = new URLSearchParams();
            const groups = {};

            form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
                const name = input.name.replace("[]", "");
                (groups[name] ||= []).push(input.value);
            });
            Object.entries(groups).forEach(([name, values]) => params.set(name, values.join(",")));

            const plaats = form.querySelector('select[name="plaats"]');
            if (plaats?.value) params.set("plaats", plaats.value);
            if (page > 1) params.set("pagina", String(page));

            return params;
        };

        const applyUrl = () => {
            const params = new URLSearchParams(window.location.search);

            form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                const values = (params.get(input.name.replace("[]", "")) || "").split(",");
                input.checked = values.includes(input.value);
            });

            const plaats = form.querySelector('select[name="plaats"]');
            if (plaats) plaats.value = params.get("plaats") || "";

            return Number(params.get("pagina")) || 1;
        };

        let request = null;

        const load = async (page = 1, { push = true, scroll = false } = {}) => {
            request?.abort();
            request = new AbortController();
            results.setAttribute("aria-busy", "true");
            layout.classList.add("is-loading");

            const body = new URLSearchParams({
                action: "bz_vacature_filter",
                post_id: layout.dataset.postId,
                selector: layout.dataset.selector,
                row: layout.dataset.row,
                layout: layout.dataset.layout,
                base: layout.dataset.base,
                query: query(page).toString(),
            });

            try {
                const response = await fetch(layout.dataset.ajaxUrl, { method: "POST", body, signal: request.signal });
                const json = await response.json();
                if (!json.success) throw new Error("vacature_filter");

                grid.innerHTML = json.data.html;
                if (pagination) pagination.innerHTML = json.data.pagination;
                if (label) label.textContent = json.data.label;
                if (empty) empty.hidden = json.data.total > 0;
                if (count) {
                    count.textContent = json.data.count;
                    count.parentElement.hidden = !json.data.count;
                }
                if (reset) reset.hidden = !json.data.count;
                if (push && json.data.url !== window.location.href) history.pushState({ vacatureFilter: true }, "", json.data.url);

                if (scroll) {
                    results.scrollIntoView({ behavior: reduceMotion.matches ? "auto" : "smooth", block: "start" });
                }
            } catch (error) {
                if (error.name !== "AbortError") console.error(error);
            } finally {
                results.setAttribute("aria-busy", "false");
                layout.classList.remove("is-loading");
            }
        };

        form.addEventListener("change", () => load(1));
        form.addEventListener("submit", (event) => {
            event.preventDefault();
            load(1);
        });

        reset?.addEventListener("click", (event) => {
            event.preventDefault();
            form.querySelectorAll('input[type="checkbox"]').forEach((input) => (input.checked = false));
            const plaats = form.querySelector('select[name="plaats"]');
            if (plaats) plaats.value = "";
            load(1);
        });

        pagination?.addEventListener("click", (event) => {
            const link = event.target.closest("a[data-page]");
            if (!link) return;
            event.preventDefault();
            load(Number(link.dataset.page), { scroll: true });
        });

        window.addEventListener("popstate", () => load(applyUrl(), { push: false }));

        layout.querySelectorAll(".filter-group-toggle").forEach((toggle) => {
            const panel = layout.querySelector(`#${toggle.getAttribute("aria-controls")}`);
            toggle.addEventListener("click", () => {
                const open = toggle.getAttribute("aria-expanded") !== "true";
                toggle.setAttribute("aria-expanded", String(open));
                if (panel) panel.hidden = !open;
            });
        });

        const title = layout.querySelector(".filters-title");
        const groups = layout.querySelector(".filters-groups");
        const syncTitle = () => {
            if (!title || !groups) return;
            title.disabled = !stacked.matches;
            title.setAttribute("aria-expanded", String(!stacked.matches));
            groups.hidden = stacked.matches;
        };
        title?.addEventListener("click", () => {
            const open = title.getAttribute("aria-expanded") !== "true";
            title.setAttribute("aria-expanded", String(open));
            groups.hidden = !open;
        });
        stacked.addEventListener("change", syncTitle);
        syncTitle();
    });
});
